import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import SvgHome from './SvgHome';
import KuposModal from './KuposModal';
import KuposButton from './KuposButton';
import CommonService from '../../services/commonService';
import { AppData } from '../../services';

export class DeleteCard extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    t: PropTypes.func,
    userCards: PropTypes.object.isRequired,
    selectedItemForDeletion: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      name: null,
      cardNumber: null,
      loading: false,
    };
  }

  deleteCard = () => {
    this.setState({ loading: true });
    let data = {
      card_number: this.props.selectedItemForDeletion[0],
      card_type: this.props.selectedItemForDeletion[2],
      card_cat: this.props.selectedItemForDeletion[1],
    };
    this.props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/remove_kupos_card',
        type: 'home',
        data: data,
        method: 'POST',
      })
      .then(
        res => this.onCardRemoval(res),
        err => this.onCardRemoval(err),
      );
  };

  onCardRemoval = result => {
    console.log('Remocal card -------------', result);
    this.setState({ loading: false });

    this.props.onCardRemoved(result);
  };

  renderName = (val, key) => {
    return <span>{this.props.selectedItemForDeletion === key ? val.name : null}</span>;
  };
  renderCardNumber = (val, key) => {
    return <span>{this.props.selectedItemForDeletion === key ? val.cardNumber : null}</span>;
  };
  render() {
    return (
      <div className="common-delete-bip-card">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="login-signup-block delete-bip-card">
            <div className="close-button pointer" onClick={this.props.onHide}>
              <SvgHome name="close" />
            </div>

            <div>
              <span className="bold-text font12 bip-pop-up-title">
                {this.props.t('PROFILE.REMOVE_CARD').split('\n')[0]}
                <br />
                {this.props.t('PROFILE.REMOVE_CARD').split('\n')[1]}
              </span>
              <div className="bip-popup-sub-body">
                <div>
                  <div className="display-flex font10 ">
                    <span className="bold-text">{this.props.t('PROFILE.NAME')}: </span>
                    &nbsp;
                    {/* {this.props.userCards
                      ? this.props.userCards.map((val, key) => this.renderName(val, key))
                      : null} */}
                    {CommonService.capitalize(
                      this.props.data &&
                        this.props.data.loginData &&
                        this.props.data.loginData.name &&
                        this.props.data.loginData.last_name &&
                        this.props.data.loginData.name + ' ' + this.props.data.loginData.last_name,
                    )}
                  </div>

                  <div className="display-flex font10">
                    <span className="bold-text">{this.props.t('PROFILE.CARD_NUMBER')}: </span>
                    &nbsp;
                    {/* {this.props.userCards
                      ? this.props.userCards.map((val, key) => this.renderCardNumber(val, key))
                      : null} */}
                    {this.props.selectedItemForDeletion &&
                      this.props.selectedItemForDeletion[0].replace(/X/gi, '*').substring(8, 12) +
                        ' ' +
                        this.props.selectedItemForDeletion[0].substring(12, 16)}
                  </div>
                </div>
              </div>

              <div className="bip-popup-button-container">
                <KuposButton onClick={this.deleteCard} className="bip-popup-button1 font12">
                  {this.state.loading ? (
                    <div className="loader-cricle"></div>
                  ) : (
                    this.props.t('PROFILE.REMOVE_BIP_BUTTON')
                  )}
                </KuposButton>

                <KuposButton onClick={this.props.onHide} className="bip-popup-button2 font12">
                  {this.props.t('PROFILE.KEEP_BIP_BUTTON')}
                </KuposButton>
              </div>
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCard);



// WEBPACK FOOTER //
// ./src/features/common/DeleteCard.js